import * as moment from 'moment';

import { BASE_TIME_FORMAT } from '../../constants';


function sortDescBy<T>(
	items: Array<T>,
	selectors: Array<{
		fn: (item: T) => any;
		isDate?: boolean;
	}>
): Array<T> {
	const itemsImmutable = [...items];

	const compare = (a, b, selector, isDate) => {
		if (!isDate) {
			if (selector(a) === selector(b)) {
				return 0;
			}
			return selector(a) < selector(b) ? 1 : -1;
		} else {
			let format = BASE_TIME_FORMAT;

			if (moment(selector(a), format).isSame(moment(selector(b), format))) {
				return 0;
			}
			return moment(selector(a), format).isBefore(moment(selector(b), format)) ? 1 : -1;
		}
	};

	const sort = (items, selectors) => {
		items.sort((a, b) => {
			for (let i = 0; i < selectors.length; i++) {
				if (compare(a, b, selectors[i].fn, selectors[i].isDate) === 0 && selectors[i + 1]) {
					return compare(a, b, selectors[i + 1].fn, selectors[i + 1].isDate);
				}
				return compare(a, b, selectors[i].fn, selectors[i].isDate);
			}
		});
	}

	if (itemsImmutable.length > 0) {
		sort(itemsImmutable, selectors);
	}

	return itemsImmutable;
}

function sortAscBy<T>(
	items: Array<T>,
	selectors: Array<{
		fn: (item: T) => any;
		isDate?: boolean;
	}>
): Array<T> {
	const itemsImmutable = [...items];

	const compare = (a, b, selector, isDate) => {
		if (!isDate) {
			if (selector(a) === selector(b)) {
				return 0;
			}
			return selector(a) < selector(b) ? -1 : 1;
		} else {
			let format = BASE_TIME_FORMAT;

			if (moment(selector(a), format).isSame(moment(selector(b), format))) {
				return 0;
			}
			return moment(selector(a), format).isBefore(moment(selector(b), format)) ? -1 : 1;
		}
	};

	const sort = (items, selectors) => {
		items.sort((a, b) => {
			for (let i = 0; i < selectors.length; i++) {
				if (compare(a, b, selectors[i].fn, selectors[i].isDate) === 0 && selectors[i + 1]) {
					return compare(a, b, selectors[i + 1].fn, selectors[i + 1].isDate);
				}
				return compare(a, b, selectors[i].fn, selectors[i].isDate);
			}
		});
	}

	if (itemsImmutable.length > 0) {
		sort(itemsImmutable, selectors);
	}

	return itemsImmutable;
}

export {
	sortDescBy,
	sortAscBy,
};
